<template>
  <div>
    <app-collapse type="margin">
      <app-collapse-item title="Fator de Risco" :is-visible="true">
        <FatorRisco
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>
      <app-collapse-item title="Sintomatologia" :is-visible="true">
        <Sintomatologia
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>
      <app-collapse-item title="Medicamento em Uso" :is-visible="true">
        <Medicamentos
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>
      <app-collapse-item title="Exame Físico" :is-visible="true">
        <ExameFisico
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>

      <app-collapse-item
        title="Exames Complementares Necessários"
        :is-visible="true"
      >
        <ExamesComplementares
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>
      <app-collapse-item title="Conclusão" :is-visible="true">
        <Conclusao
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>
      <app-collapse-item title="Recomendações" :is-visible="true">
        <Recomendacoes
          :parecer="parecer"
          @disable-form-changed="handleDisableFormChange"
        />
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ExameFisico from "./ExameFisico.vue";
import FatorRisco from "./FatorRisco.vue";
import Sintomatologia from "./Sintomatologia.vue";
import Recomendacoes from "./Recomendacoes.vue";
import ExamesComplementares from "./ExamesComplementares.vue";
import Conclusao from "./Conclusao.vue";
import Medicamentos from "./Medicamentos.vue";

export default {
  name: "DigitalParecerCardiologico",
  components: {
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    ExameFisico,
    FatorRisco,
    Sintomatologia,
    Recomendacoes,
    ExamesComplementares,
    Conclusao,
    Medicamentos,
  },
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exameFisico: {
        eg: null,
        dispneia: false,
        cianose: false,
        palidez: false,
        edemas: false,
        ictericia: false,
        pulsosAnormais: false,
        turgenciaJugular: false,
        outros: null,
        auscultaPulmonar: {
          status: null,
          descricao: null,
        },
        auscultaCardiaca: {
          rc: null,
          fc: null,
          bpm: null,
          descricao: null,
        },
        pa: {
          sistolica: null,
          diastolica: null,
          unidade: null,
          outrosDescricao: null,
        },
      },
      fatorRisco: {
        has: false,
        diabetes: false,
        tabagismo: false,
        sedentarismo: false,
        disfuncaoTireoidiana: false,
        febreReumaticaPrevia: false,
        dpoc: false,
        trombofilias: false,
        hereditariedadeDac: false,
        obesidade: false,
        nefropatias: false,
        outros: false,
        outrosDescricao: null,
      },
      sintomatologia: {
        dorToracicaTipica: false,
        dispneia: false,
        palpitacoes: false,
        tonturas: false,
        cefaleia: false,
        sincopal: false,
        convulsao: false,
        edemas: false,
        tosseSeca: false,
        tosseProdutiva: false,
        perdaDePeso: false,
        queixasUrinarias: false,
        outros: false,
        outrosDescricao: null,
      },
      recomendacoes: {
        recomendacoes: null,
      },
      examesComplementares: {
        ecg: {
          ritmo: null,
          tracado: null,
          alteradoDescricao: null,
        },
        testeErgometrico: {
          resultado: null,
          descricao: null,
        },
        ecodopplerCardiograma: {
          resultado: null,
          descricao: null,
        },
        mapa: {
          resultado: null,
          descricao: null,
        },
        holterDeArritmias: {
          resultado: null,
          descricao: null,
        },
        outros: null,
      },
      conclusao: {
        resultado: null,
        descricao: null,
      },
      unidadeOptions: [
        { value: null, text: "Selecione a unidade" },
        { value: "mmHg", text: "mmHg" },
        { value: "cmH2O", text: "cmH2O" },
      ],
    };
  },
  computed: {},
  watch: {
    parecer: {
      handler(newVal) {
        if (newVal && newVal.exameFisico) {
          this.setExameFisicoData(newVal);
        }
        if (newVal && newVal.fatorRisco) {
          this.setFatorRiscoData(newVal);
        }
        if (newVal && newVal.sintomatologia) {
          this.setSintomatologiaData(newVal);
        }
        if (newVal && !!newVal.recomendacoes) {
          this.setRecomendacaoData(newVal);
        }
        if (newVal && newVal.examesComplementares) {
          this.setExamesComplementaresData(newVal);
        }
        if (newVal && newVal.conclusao) {
          this.setConclusaoData(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getExameFisicoData() {
      return this.exameFisico;
    },
    setExameFisicoData(data) {
      if (data && data.exameFisico) {
        this.exameFisico = { ...this.exameFisico, ...data.exameFisico };
      }
    },
    getFatorRiscoData() {
      return this.fatorRisco;
    },
    setFatorRiscoData(data) {
      if (data && data.exameFisico && data.fatorRisco) {
        this.fatorRisco = { ...this.fatorRisco, ...data.fatorRisco };
      }
    },
    getRecomendacaoData() {
      return this.recomendacoes;
    },
    setRecomendacaoData(data) {
      if (data && !!data.recomendacoes) {
        this.recomendacoes = data.recomendacoes;
      }
    },
    getSintomatologiaData() {
      return this.sintomatologia;
    },
    setSintomatologiaData(data) {
      if (data && data.sintomatologia) {
        this.sintomatologia = data.sintomatologia;
      }
    },
    getExamesComplementaresData() {
      return this.examesComplementares;
    },
    setExamesComplementaresData(data) {
      if (data && data.examesComplementares) {
        this.examesComplementares = data.examesComplementares;
      }
    },
    getConclusaoData() {
      return this.conclusao;
    },
    setConclusaoData(data) {
      if (data && data.conclusao) {
        this.conclusao = data.conclusao;
      }
    },
    handleDisableFormChange(disableFormValue) {
      this.$emit("disable-form-changed-parecer", disableFormValue);
    },
  },
};
</script>

<style scoped></style>
